/**
 * Shared placeholder for any surface that exists in navigation but has no
 * built implementation yet. Every dead-end control routes here instead of
 * rendering as a disabled or inert element.
 */
export function UnderConstruction(props: {
  title: string;
  detail?: string;
  backHref?: string;
  backLabel?: string;
}) {
  return (
    <section class="under-construction" aria-label="Under construction">
      <span class="under-construction-badge">Under construction</span>
      <h2>{props.title}</h2>
      <p>
        {props.detail ??
          "This part of Faro Signal is not built yet. It is on the roadmap and will light up here when it ships."}
      </p>
      {props.backHref ? (
        <a class="under-construction-back" href={props.backHref}>
          {props.backLabel ?? "Back to Overview"}
        </a>
      ) : null}
    </section>
  );
}
